
import ExcelJS from 'exceljs'

export const exportToExcel = async (jsonData: any, type: string): Promise<void> => {
  const workbook = new ExcelJS.Workbook()
  const worksheet = workbook.addWorksheet('Sheet 1')
  // Add data rows
  jsonData.forEach((rowData: any, index: number) => {
    const cleanedRow = rowData.map((cell: any) => {
      // Convert numeric-looking strings to real numbers
      if (typeof cell === 'string' && !isNaN(Number(cell)) && cell.trim() !== '') {
        return Number(cell) // e.g., "0.000" => 0
      }
      return cell
    })
    worksheet.addRow(cleanedRow)
  })

  // Auto width logic
  worksheet.columns.forEach((column: any) => {
    let maxLength = 10
    column.eachCell({ includeEmpty: true }, (cell: any) => {
      const cellValue = cell.value?.toString() ?? ''
      maxLength = Math.max(maxLength, cellValue.length)
    })
    column.width = maxLength + 2 // Add padding
  })

  // Write to Excel buffer and trigger download
  await workbook.xlsx.writeBuffer().then((buffer) => {
    const blob = new Blob([buffer], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    })
    const url = window.URL.createObjectURL(blob)

    const link = document.createElement('a')
    link.href = url
    const today = new Date()
    const time = today.toLocaleTimeString([], {
      hourCycle: 'h23',
      minute: '2-digit',
      second: '2-digit'
    })
    link.setAttribute(
      'download',
        `${String(type[0]).toUpperCase() + String(type).slice(1)}_GraphData_${
          today.getMonth() + 1
        }-${today.getDate()}-${today.getFullYear()} ${today.getHours()}_${time}.xlsx`
    )
    document.body.appendChild(link)
    link.click()
    link.parentNode?.removeChild(link)
  }).catch((ex) => {
    throw ex.errorMessage
  })
}
